module.exports = __webpack_public_path__ + "assets/smiley-confused.ccdeead50cc1c431908ea8b0a3254897.svg";